/// <amd-module name="TFS/CreateProject/StoresHub" />
import { ActionsHub } from "TFS/CreateProject/ActionsHub";
import { StoreListener } from "TFS/CreateProject/Shared/StoreListener";
import { Store } from "TFS/CreateProject/Store";

/**
 * A container to hold the multiple stores of project creation page
 */
export class StoresHub {
    private _store: Store;
    private _storeListener: StoreListener;

    constructor(
        private _actionsHub: ActionsHub,
        private _source: string,
        private _versionControlType?: string,
        private _processTemplate?: string,
        private _projectVisibility?: string,
        private _featureIds?: string[]
    ) {
        this._storeListener = new StoreListener();

        // Project creation metadata load listeners
        this._storeListener.addListener(this._actionsHub.projectCreationMetadataLoadStarted, this.store.onProjectCreationMetadataLoadStatusChanged);
        this._storeListener.addListener(this._actionsHub.projectCreationMetadataLoadSucceeded, this.store.onProjectCreationMetadataLoadStatusChanged);
        this._storeListener.addListener(this._actionsHub.projectCreationMetadataLoadFailed, this.store.onProjectCreationMetadataLoadStatusChanged);
        this._storeListener.addListener(this._actionsHub.existingProjectNamesFetched, this.store.updateExistingProjectNames);

        // Project creation related action listeners
        this._storeListener.addListener(this._actionsHub.projectCreationSucceeded, this.store.onProjectCreationStatusChanged);
        this._storeListener.addListener(this._actionsHub.projectCreationFailed, this.store.onProjectCreationStatusChanged);
        this._storeListener.addListener(this._actionsHub.projectCreationStarted, this.store.onProjectCreationStatusChanged);

        // Project name validation related actions listeners
        this._storeListener.addListener(this._actionsHub.projectNameValidationSucceeded, this.store.onProjectNameValidationStatusChanged);
        this._storeListener.addListener(this._actionsHub.projectNameValidationFailed, this.store.onProjectNameValidationStatusChanged);
        this._storeListener.addListener(this._actionsHub.projectNameValidationReset, this.store.onProjectNameValidationStatusChanged);

        // Project limit check related actions listeners
        this._storeListener.addListener(this._actionsHub.projectLimitCheckSucceeded, this.store.onProjectLimitCheckStatusChanged);
        this._storeListener.addListener(this._actionsHub.projectLimitCheckFailed, this.store.onProjectLimitCheckStatusChanged);

        // Project parameters related listeners
        this._storeListener.addListener(this._actionsHub.projectDescriptionChanged, this.store.onProjectDescriptionChanged);
        this._storeListener.addListener(this._actionsHub.versionControlChanged, this.store.onVersionControlTypeChanged);
        this._storeListener.addListener(this._actionsHub.projectVisibilityChanged, this.store.onProjectVisibilityOptionChanged);
        this._storeListener.addListener(this._actionsHub.processTemplateChanged, this.store.onProcessTemplateChanged);

        // Status message dismissed action listener
        this._storeListener.addListener(this._actionsHub.statusMessageDismissed, this.store.onStatusMessageDismissed);

        // Advanced options action listener
        this._storeListener.addListener(this._actionsHub.advancedOptionVisibilityToggled, this.store.onAdvancedOptionVisibilityToggle);
    }

    public get store(): Store {
        if (!this._store) {
            this._store = new Store(this._source, this._versionControlType, this._processTemplate, this._projectVisibility, this._featureIds);
        }
        return this._store;
    }

    public dispose(): void {
        if (this._storeListener) {
            this._storeListener.disposeAllListeners();
        }
    }
}
